import { __awaiter } from "tslib";
import { ScheduleService } from "../../services/models/schedule/schedule";
const moduleSchedule = {
    namespaced: true,
    state: {
        schedule: [],
        loading: false,
        selectedSchedule: null,
        selectedScheduleTypeId: null,
        scheduleDetailNumber: null,
        isNotValid: false,
    },
    getters: {
        getSchedule(state) {
            return state.schedule;
        },
        getLoading(state) {
            return state.loading;
        },
        getSelectedSchedule(state) {
            return state.selectedSchedule;
        },
        getScheduleByConsultant(state) {
            return state.schedule;
        },
        getIsNotValid(state) {
            return state.isNotValid;
        },
        getSelectedScheduleTypeId(state) {
            return state.selectedScheduleTypeId;
        },
        getScheduleDetailNumber(state) {
            return state.scheduleDetailNumber;
        },
    },
    mutations: {
        setSchedule(state, schedule) {
            state.schedule = schedule;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setSelectedSchedule(state, schedule) {
            state.selectedSchedule = schedule;
        },
        setIsNotValid(state, isNotValid) {
            state.isNotValid = isNotValid;
        },
        setSelectedScheduleTypeId(state, selectedScheduleTypeId) {
            state.selectedScheduleTypeId = selectedScheduleTypeId;
        },
        setScheduleDetailNumber(state, scheduleDetailNumber) {
            state.scheduleDetailNumber = scheduleDetailNumber;
        },
        removeSchedule: (state, data) => (state.schedule = state.schedule.filter((item) => item.id != data)),
        addSchedule: (state, data) => (state.schedule = [...state.schedule, data]),
        editSchedule: (state, data) => (state.schedule = state.schedule.map((item) => (item.id == data.id ? Object.assign(Object.assign({}, item), data) : item))),
    },
    actions: {
        getSchedule({ commit }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const SCHEDULE = yield ScheduleService.getAll();
                commit("setSchedule", SCHEDULE);
                commit("setLoading", false);
            });
        },
        getSelectedSchedule({ commit }, id) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const SCHEDULE = yield ScheduleService.getById(id);
                commit("setSelectedSchedule", SCHEDULE);
                commit("setLoading", false);
            });
        },
        getSelectedSchedulePerformance({ commit }, id) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const SCHEDULE = yield ScheduleService.getByIdPerformanceV2(id);
                commit("setSelectedSchedule", SCHEDULE);
                commit("setLoading", false);
            });
        },
        getScheduleByConsultant({ commit, state }, id) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const SCHEDULE = yield ScheduleService.getByConsultantPerformance({
                    consultant_id: id,
                    state: state.isNotValid ? "no vigente" : "creada",
                });
                commit("setSchedule", SCHEDULE);
                commit("setLoading", false);
            });
        },
        getScheduleByConsultantFilter({ commit }, data) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const SCHEDULE = yield ScheduleService.getByConsultantId(data);
                commit("setSchedule", SCHEDULE);
                commit("setLoading", false);
            });
        },
        updateSchedule({ commit }, { id, data }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const SCHEDULE_EDIT = yield ScheduleService.update(id, data);
                commit("setLoading", false);
                return SCHEDULE_EDIT;
            });
        },
        createSchedule({ commit }, data) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const SCHEDULE_ADD = yield ScheduleService.create(data);
                commit("setLoading", false);
                return SCHEDULE_ADD;
            });
        },
        deleteSchedule({ commit }, id) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const SCHEDULE_EDIT = yield ScheduleService.remove(id);
                commit("setLoading", false);
                return SCHEDULE_EDIT;
            });
        },
    },
};
export default moduleSchedule;
